// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"24":"71ff3b62","53":"e2d40735","71":"126c53f9","249":"c04ffde4","481":"a148a57e"}[chunkId] + ".js";
};